import React from 'react';
import { Modal, Box, SpaceBetween, Button } from '@amzn/awsui-components-console';

interface DeleteConfirmationModalProps {
	visible: boolean;
	onDismiss: () => void;
	onConfirm: () => void;
	isDeleting: boolean;
	error?: string | null;
	itemName: string;
	itemType: 'application' | 'operation';
	testIdPrefix?: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
	visible,
	onDismiss,
	onConfirm,
	isDeleting,
	itemName,
	itemType,
	testIdPrefix = 'delete-confirmation',
}) => {
	return (
		<Modal
			visible={visible}
			onDismiss={onDismiss}
			header={`Delete ${itemType}`}
			closeAriaLabel="Close modal"
			footer={
				<Box float="right">
					<SpaceBetween direction="horizontal" size="xs">
						<Button variant="link" onClick={onDismiss} disabled={isDeleting}>
							Cancel
						</Button>
						<Button
							variant="primary"
							onClick={onConfirm}
							loading={isDeleting}
							data-testid={`${testIdPrefix}-confirm`}
						>
							Delete
						</Button>
					</SpaceBetween>
				</Box>
			}
		>
			<SpaceBetween size="m">
				<Box variant="span">
					Are you sure you want to delete the {itemType}{' '}
					<Box variant="span" fontWeight="bold">
						{itemName}
					</Box>
					? This action cannot be undone.
				</Box>
			</SpaceBetween>
		</Modal>
	);
};

export default DeleteConfirmationModal;
